import React, { useState, useEffect } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/weatherForecast.scss";

// Bootstrap Components
import Container from "react-bootstrap/Container";

import { getWeatherForecast } from "../../../service/apiHKOWeatherInfoService";

// Type of information
type weatherForecastObject = {
  generalSituation: string;
  tcInfo: string;
  fireDangerWarning: string;
  forecastPeriod: string;
  forecastDesc: string;
  outlook: string;
  updateTimeYear: string;
  updateTimeMonth: string;
  updateTimeDay: string;
  updateTimeHour: string;
  updateTimeMinute: string;
};

function WeatherForecast() {
  const [weatherForecast, setWeatherForecast] =
    useState<weatherForecastObject>();

  async function getFetchForcastInfomation() {
    await getWeatherForecast()
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        let returnObject: weatherForecastObject = {
          generalSituation: data.generalSituation,
          tcInfo: data.tcInfo,
          fireDangerWarning: data.fireDangerWarning,
          forecastPeriod: data.forecastPeriod,
          forecastDesc: data.forecastDesc,
          outlook: data.outlook,
          updateTimeYear: data.updateTime.substr(0, 4),
          updateTimeMonth: data.updateTime.substr(5, 2),
          updateTimeDay: data.updateTime.substr(8, 2),
          updateTimeHour: data.updateTime.substr(11, 2),
          updateTimeMinute: data.updateTime.substr(14, 2),
        };

        setWeatherForecast(returnObject);
      });
  }

  useEffect(() => {
    getFetchForcastInfomation();
  }, []);

  return (
    <div>
      <Container>
        <div id="weatherForecastBox">
          <div id="weatherForecastBox_Title">天氣預報(天文台)</div>
          <div id="weatherForecastBox_Content">
            <div className="weatherForecastBox_Content_text">
              {weatherForecast?.generalSituation}
            </div>
            <div className="weatherForecastBox_Content_text">
              {weatherForecast?.tcInfo}
            </div>
            <div className="weatherForecastBox_Content_text">
              {weatherForecast?.forecastPeriod}
            </div>
            <div className="weatherForecastBox_Content_text">
              {weatherForecast?.forecastDesc}
            </div>
            <div className="weatherForecastBox_Content_text">
              展望：{weatherForecast?.outlook}
            </div>
            <div
              id="weatherForecastBox_Content_time"
              className="weatherForecastBox_Content_text"
            >
              {weatherForecast?.updateTimeHour}:
              {weatherForecast?.updateTimeMinute}更新
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default WeatherForecast;
